import { UserProfileApi } from '@ab-inbev/sam-api';
import { useFeaturesGetQuery } from '@ab-inbev/sam-api/clients/user-profile-api-client';

import { createContext, ReactNode, useEffect, useMemo, useState } from 'react';

export const FeatureFlagContext = createContext<{
  featureFlags: UserProfileApi.Feature[] | undefined;
}>({ featureFlags: [] }); // default values

export const FeatureFlagProvider = ({ children }: { children: ReactNode }) => {
  const { data: featureFlags, isLoading } = useFeaturesGetQuery();
  const [ready, setReady] = useState(false);

  /*
   We generally don't want the app to render before feature flags are loaded
   because that can cause the false version to render, and then it switches to the true version,
   and it looks weird.

   However, if the feature flags endpoint is down or just hangs, we still want the apps to function.
   Otherwise, this endpoint being down would prevent even brewing-calculations from being usable.
  */

  const contextValue = useMemo(() => ({ featureFlags }), [featureFlags]);

  useEffect(() => {
    if (featureFlags) {
      setReady(true);
      return;
    }
    const timer = setTimeout(() => setReady(true), 2000);
    return () => clearTimeout(timer);
  }, [featureFlags]);

  if (!isLoading || ready) {
    return <FeatureFlagContext.Provider value={contextValue}>{children}</FeatureFlagContext.Provider>;
  }
};
